// src/components/ui/InfoSection.jsx
// Bloques de presentación para fichas técnicas: campo etiqueta/valor y sección con ícono.

export const InfoField = ({ label, value, className = "" }) => (
  <div className={`space-y-0.5 min-w-0 ${className}`}>
    <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">{label}</p>
    <p className="text-sm font-medium text-gray-800 break-words">{value || "—"}</p>
  </div>
);

export const SectionCard = ({ icon: Icon, iconColor = "text-blue-500", title, children, className = "" }) => (
  <div className={`rounded-xl border border-gray-100 bg-gray-50/60 p-5 space-y-4 ${className}`}>
    <div className="flex items-center gap-2">
      {Icon && <Icon className={`h-4 w-4 shrink-0 ${iconColor}`} />}
      <h4 className="text-sm font-semibold text-gray-700">{title}</h4>
    </div>
    {children}
  </div>
);
